/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsObjectUpSubtract: {
  name: 'object-up-subtract';
  data: string;
} = {
  name: 'object-up-subtract',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v1a1 1 0 0 0 2 0V3h1a1 1 0 0 0 0-2H3Zm5 0a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2H8Zm5 0a1 1 0 1 0 0 2h1v11H8a1 1 0 1 0 0 2v5a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-5V3a2 2 0 0 0-2-2h-1Zm3 9v4a2 2 0 0 1-2 2h-4v5h11V10h-5ZM3 8a1 1 0 0 0-2 0v1a1 1 0 0 0 2 0V8Zm0 5a1 1 0 1 0-2 0v1a2 2 0 0 0 2 2h1a1 1 0 1 0 0-2H3v-1Z" fill="currentColor"/></svg>`,
};
